import { useHistorySearchQuery, useWindowSize } from '@/hooks';
import {
  Button,
  Card,
  Layout,
  Space,
  Tooltip,
  Typography,
  message,
} from 'antd';
import { Link } from 'react-router-dom';

import logoMin from '@/assets/images/Logo-UC-mobile.png';
import logo from '@/assets/images/Logo_Footer.png';
import CopyIcon from '@/components/_common/CopyIcon';
import { Phone } from 'react-feather';
import moment from 'moment';
import { APP_NAME, isAppPortocar } from '@/index';

export default function ExpiredPage() {
  const { id } = useHistorySearchQuery();

  const { isMobile } = useWindowSize();
  return (
    <Layout style={{ height: '100vh' }}>
      <Layout.Header className="help-center-header">
        <div
          className="help-center-header-content"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Link to="/login">
            {isMobile ? (
              <div className="logoMin">
                <img
                  className="image"
                  src={
                    isAppPortocar
                      ? '/images/Logo_PortoCar_branca-icon.svg'
                      : logoMin
                  }
                  alt="logo"
                  style={{ width: '60px' }}
                />
              </div>
            ) : (
              <div className="logo">
                <img
                  className="image"
                  src={
                    isAppPortocar ? '/images/Logo_PortoCar_branca.svg' : logo
                  }
                  alt="logo"
                />
              </div>
            )}
          </Link>
          <a style={{ color: 'white' }} href="tel:+553132132354">
            <Phone size={14} /> (31) 3213-2354
          </a>
        </div>
      </Layout.Header>
      <Layout.Content
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          margin: '0 5px',
        }}
      >
        <Card
          title={
            <Typography.Text
              style={{ whiteSpace: 'break-spaces', margin: '0 10px' }}
            >
              O seu período de utilização do sistema expirou
            </Typography.Text>
          }
          style={{
            maxWidth: '500px',
            height: 'max-content',
            borderRadius: '10px',
          }}
        >
          <Space
            direction="vertical"
            style={{ textAlign: 'center', margin: '0 10px' }}
          >
            <Typography.Text>
              Entre em contato com a plataforma {APP_NAME} e contrate um plano
              para continuar aproveitando os benefícios do sistema!
            </Typography.Text>
            <Typography.Text>Seu código é: {id || '-'}</Typography.Text>
            <a href="tel:+553132132354">
              <strong>
                <Phone size={12} /> (31) 3213-2354
              </strong>
            </a>
            <Tooltip title="copiar email" placement="bottom">
              <Button
                icon={<CopyIcon iconProps={{ size: 12 }} />}
                type="link"
                onClick={() => {
                  navigator.clipboard.writeText('comercial@ultracar.com.br');
                  message.info('email copiado');
                }}
              >
                comercial@ultracar.com.br
              </Button>
            </Tooltip>
          </Space>
        </Card>
      </Layout.Content>
      <Layout.Footer style={{ textAlign: 'center' }}>
        Copyright © {moment().year()} Ultracar Tecnologia e Informação LTDA.
        Todos os direitos reservados.
      </Layout.Footer>
    </Layout>
  );
}
